import React, { useState } from 'react';
import './Filter.css';

import evaluationImage from '../../img/evaluation2.jpg'
import customImage from '../../img/custom2.png'
import webImage from '../../img/web_dev2.png'
import mobileImage from '../../img/mobile3.png'
// import supportImage from '../../img/support.jpg'



export default function FilterHome() {
  const [selectedItem, setSelectedItem] = useState('Evaluation & Design');

  const items = [
    {
      id: '01/',
      title: 'Evaluation & Design',
      description:
        'Evaluation in software development involves assessing the requirements, feasibility, and performance of a system or its components.The design phase focuses on creating a blueprint for the software, including both high-level and detailed design.',
      tags: [
        'Requirements Evaluation',
        'Feasibility Analysis',
        'Performance Evaluation',
        'High-Level Design (System Architecture)',
        'Detailed Design',
        '⁠User Interface (UI) Design',

      ],
      image: evaluationImage,
    },
    {
      id: '02/',
      title: 'Custom Software',
      description:
        'We specialize in providing high-quality, tailored software development solutions that help businesses solve complex challenges, enhance operational efficiency, and drive innovation. Whether you are a startup looking to create a unique product or an established enterprise in need of customized systems, our team has the expertise to bring your vision to life.',
      tags: ['Increased Efficiency', 'Scalability', 'Better Security', 'Competitive Advantage'],
      image: customImage,
    },
    {
      id: '03/',
      title: 'Web Development',
      description:
        'Lorem ipsum dolor sit amet consectetur adipiscing elit. Proin dapibus quis sociis dui condimentum rutrum.',
      tags: ['Frontend', 'Backend', 'APIs', 'Responsive Design'],
      image: webImage,
    },
    {
      id: '04/',
      title: 'Mobile Development',
      description:
        'Lorem ipsum dolor sit amet consectetur adipiscing elit. Curabitur in libero fermentum, tristique ligula sit amet.',
      tags: ['ios app',

        'android app',

        'react native',

        'flutter',

        'cross-platform',

        'hybrid app',

        'single page'],
      image: mobileImage,
    },
    {
      id: '05/',
      title: 'Maintenance & Support',
      description:
        'Lorem ipsum dolor sit amet consectetur adipiscing elit. Integer gravida orci eu tincidunt efficitur.',
      tags: ['Bug Fixes', 'Performance Tuning', 'Security Updates'],
      image: customImage,
    },
  ];

  const selectedContent = items.find((item) => item.title === selectedItem);

  return (
    <div className="filter-container">
      {/* Left Side Menu */}
      <div className="left-panel">
        {items.map((item) => (
          <div
            key={item.id}
            className={`menu-item ${selectedItem === item.title ? 'active' : ''}`}
            onClick={() => setSelectedItem(item.title)}
          >
            <span className="menu-item-id">{item.id}</span>
            <span className="menu-item-title">{item.title}</span>
          </div>
        ))}
      </div>


      <div className="right-panel">
        <div className="content-container">

          <div className="content-text">


            <div className="tags-section">
              {selectedContent.tags.map((tag, index) => (
                <span key={index} className="tag">
                  {tag}
                </span>
              ))}
            </div>
            <p className="right-panel-description">{selectedContent.description}</p>
            <button className="learn-more">Learn More <span>🡥</span></button>
          </div>

          {/* Image Section */}

          <div className="content-image">
            <div className="orange-background"></div>
            <img
              src={selectedContent.image}
              alt={selectedContent.title}
              className="main-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
